var Block_Galery = {
	init:function(){
		var _carousel = $(".block-galery .galery-list");
		
		_carousel.slick({
			arrows:true, 
			dots:false,
			infinite: true,
			variableWidth:true,
			slidesToShow: 1,
			focusOnSelect: true,
			touchThreshold:500,
			prevArrow:"",
			nextArrow:_carousel.parent().find(".arrow-next"),
		});
	}
}

$(window).load(function(){
	if($(".block-galery").length){
		Block_Galery.init();
	}
})